import { ChangeDetectionStrategy, Component, inject, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { IAccessRightFilterCollection, ILightWeightObject, ILightWeightUser } from '@fi-shared/models';
import { FiTaskAssignmentType } from '@fi-app/task-v2/fi-task-v2-enums';

@Component({
    selector: 'fi-task-v2-edit-assign',
    templateUrl: './fi-task-v2-edit-assign.component.html',
    styleUrl: './fi-task-v2-edit-assign.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-edit-assign' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiTaskV2EditAssignComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiTaskV2EditAssignComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiTaskV2EditAssignComponent
    extends ControlValueAccessorValidatorBase<IAccessRightFilterCollection>
    implements OnInit
{
    @Input({ required: true }) availableUsers: ILightWeightUser[];
    @Input({ required: true }) availableRoles: ILightWeightObject[];
    @Input({ required: true }) availableUnits: ILightWeightObject[];
    @Input({ required: true }) taskCreatedByUserId: number;
    @Input({ required: true }) assignmentType: FiTaskAssignmentType;
    //@Output() assigneeTargetChange = new EventEmitter<FiTaskAssignmentType>(); // not used?

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {}
}
